// layouts
import ArmilisLayout from "../armilis/ArmilisLayout";
import TrustConserveLayout from "../trustconserve/TrustConserveLayout";
import TrustConserveDefault from "../trustconserve/TrustConserveDefault";
import AMGLayout from "../amg/AMGLayout";
import AlsaLayout from "../alsa/AlsaLayout";
import WilktronicsLayout from "../wilktronics/WilktronicsLayout";
import _jZP9Zja79jLayout from "../tags/_jZP9Zja79j/_jZP9Zja79jLayout";
import DefaultLayout from "../default/DefaultLayout";

// A ---------------------------------------------------------------------- M

import { ArmilisTheme, TrustConserveTheme, AMGTheme, AlsaTheme, WilktronicsXArmilisTheme, _jZP9Zja79jTheme, DefaultTheme } from "themes/config";

export const layoutRegistry = {
  armilis: { layout: ArmilisLayout, theme: ArmilisTheme },
  trustConserve: { layout: TrustConserveLayout, theme: TrustConserveTheme },
  trustConserveDefault: { layout: TrustConserveDefault, theme: TrustConserveTheme },
  amg: { layout: AMGLayout, theme: AMGTheme },
  alsa: { layout: AlsaLayout, theme: AlsaTheme },
  wilktronics: { layout: WilktronicsLayout, theme: WilktronicsXArmilisTheme },
  jzp9zja79j: { layout: _jZP9Zja79jLayout, theme: _jZP9Zja79jTheme },
  default: { layout: DefaultLayout, theme: DefaultTheme },
};
